import React from "react";
import ReactDOM from "react-dom/client";
import CollapsibleSection from "../components/CollapsibleSection.jsx";
import './frontend.css';

document.querySelectorAll(".wp-block-bigsave-simple-collapsible-section").forEach((div) => {
  const data = JSON.parse(div.querySelector("pre").innerText);
  const savedHTML = div.querySelector(".inner-content")?.innerHTML || "";
  div.innerHTML = ""; // Clear container before mounting React
  
  ReactDOM.createRoot(div).render(
    <CollapsibleSection
      header={data.header}
      sectionName={data.header}
      defaultOpen={data.defaultOpen || false}
      arrowColour={data.arrowColour || "var(--wp--preset--color--bigsave-primary)"}
    >
      <div dangerouslySetInnerHTML={{ __html: savedHTML }} />
    </CollapsibleSection>
  );
});